import { Component, Event, EventEmitter, getAssetPath, h, Host, Prop, State } from '@stencil/core';

import wcShared from '@web-components/shared';

import helpdeskCommon from '../../../../utils/HelpdeskCommon.class';
import { FaqsStore } from '../../../../utils/Stores/faqs-store';
import { Store } from '../../../../utils/Stores/store';

@Component({
  tag: 'faq-list-module',
  styleUrl: 'faq-list-module.scss',
  shadow: true,
})
export class ModuleFaqList {
  @Prop({ mutable: true }) search: string;

  @State() faqs: IWCFaqs;
  @State() loadingFaq = false;

  @Event() sectionChangeEvent: EventEmitter<IWCContextClose[]>;

  async componentWillLoad() {
    await this.getFaq();
  }

  private inputOnChange(event) {
    if (event.data !== ' ') {
      this.loadingFaq = true;
    }

    wcShared?.store?.utils.debounce(this.getFaq.bind(this), event.target.value, 500, 1);
  }

  private getFaq(text?: string, id?: number) {
    // Don't call function if we have already the datas
    if (!Boolean(text) && !Boolean(id) && FaqsStore?.get('faqs')?.total !== 0) {
      return;
    }

    const lang = wcShared?.store?.utils?.getLang();
    this.loadingFaq = true;
    wcShared?.store?.loaderStart('loadingFaq');
    this.search = text;

    let url = `/api/components/chatbot/faq/search?lang=${lang}`;
    url += helpdeskCommon.urlFormatFaq(text, id);

    return wcShared
      .httpCall('GET', url)
      .then((r) => {
        if (r.status === 200) {
          r.json().then((response) => {
            const data = response.data;
            FaqsStore?.set('faqs', {
              faq: data.faq,
              total: data.total,
            });
            wcShared?.store?.loaderStop('loadingFaq').then(() => (this.loadingFaq = false));
          });
        }
      })
      .catch(() => {
        wcShared?.store?.loaderStop('loadingFaq').then(() => (this.loadingFaq = false));
      });
  }

  private onAllFaqRedirect = () => {
    // Delete cookie use to open the chatbot when redirected from all faq
    if (Store.get('isMobile')) {
      wcShared?.store?.utils?.setCookie('IkHelpdeskOpen', 'false', 365);
    }
  };

  private goToFaq(faq: IWCFaq) {
    FaqsStore?.set('current', faq);
    this.sectionChangeEvent.emit(['faq_item']);
  }

  private goToContact(event: MouseEvent) {
    event.preventDefault();
    this.sectionChangeEvent.emit(['contact_list']);
  }

  render() {
    return (
      <Host>
        <div class={{ 'faq-all': true, 'faq-all--full': Store?.get('is_full') }}>
          <div class="faq-all-search">
            <input
              onInput={(event) => this.inputOnChange(event)}
              placeholder={wcShared.translate('Quelle est votre question ?')}
              autocomplete="off"
              type="text"
            />
            <img
              class="faq-all-search__icon"
              src={getAssetPath('./../assets/icons/search.svg')}
              alt="Chat bot"
            />
          </div>
          <div class="faq-all-list">
            <module-loader-component class={{ hide: !this.loadingFaq }}></module-loader-component>
            {FaqsStore?.get('faqs')?.total > 0 && !this.loadingFaq ? (
              <div class="faq-all-list__container">
                <h3>{wcShared.translate("Nous vous suggerons les FAQ's suivantes :")}</h3>
                <ul>
                  {FaqsStore?.get('faqs')?.faq?.map((faq) => {
                    if (Boolean(faq.title)) {
                      return (
                        <li onClick={() => this.goToFaq(faq)}>
                          <faq-list-item-module faq={faq}></faq-list-item-module>
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
            ) : (
              <div class={{ 'faq-all-list__empty': true, hide: this.loadingFaq }}>
                {wcShared.translate(
                  'Il semble quil ny ai aucun resultat pour votre recherche, verifiez votre question ou changez de mots cles',
                )}
              </div>
            )}
          </div>
          <div class="faq-all-action">
            <div class="faq-all-action__guides">
              <a
                href="https://www.infomaniak.com/gtl/support.faq"
                onClick={this.onAllFaqRedirect}
              >
                {wcShared?.translate('Tous les guides')}
              </a>
            </div>
            <div class={{ 'faq-all-action__contact': true, hide: !Store?.get('onError') }}>
              <a
                href="#"
                onClick={(event) => {
                  this.goToContact(event);
                }}
              >
                {wcShared?.translate('Contacter le support')}
              </a>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
